// extracted by mini-css-extract-plugin
module.exports =  {"roleAutocomplete":"roleAutocomplete--XhYuJuEKKCYe64SBTFDvnA=="};